import { type SessionsAsset, useGetDemoQuery } from '@carboncopyco/data';
import { ShowOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TooltipBubble } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useDashboardProps } from '../../DashboardContext';
import { useWorkspaceAccess } from '../../hooks';

export const RowPreviewButton = ({ demo }: { demo: SessionsAsset }) => {
  const { organizationId, goToDemoPreview, goToArchivedDemoPreview } =
    useDashboardProps();
  const { assetId, firstUrl, workspaceId, isDeleted } = demo;
  const { userHasWorkspaceAccess } = useWorkspaceAccess({
    workspaceId,
  });
  const { data: demoData, error } = useGetDemoQuery(
    {
      id: assetId,
      workspaceId,
      organizationId,
    },
    { skip: !userHasWorkspaceAccess }
  );

  const onClick = (event) => {
    event.stopPropagation();
    if (error) {
      return undefined;
    }
    if (isDeleted && demoData?.playerToken) {
      goToArchivedDemoPreview({
        id: Number(assetId),
        firstUrl,
        playerToken: demoData.playerToken,
        workspaceId,
      });
      return;
    }
    return goToDemoPreview({
      id: Number(assetId),
      firstUrl,
      workspaceId,
    });
  };

  return (
    <div
      onClick={onClick}
      className={classNames({ onClick: 'cursor-pointer' })}
    >
      <TooltipBubble
        title="Preview"
        placement="top"
      >
        <ShowOutlineIcon
          size={16}
          color={error ? ColorHex.natural200 : ColorHex.natural600}
        />
      </TooltipBubble>
    </div>
  );
};
